module.exports = __webpack_public_path__ + "img/Sam.4d7a0983.jpg";